module.exports = __webpack_public_path__ + "static/media/1POLICY9.7bdbab19.jpg";